"use strict";

/**
 * @classdesc
 * Aktion zum (de-)aktivieren der Anzeige von Meldungen eines Log-Levels.
 *
 * @class
 * @extends gc.gis.action.GCAbstractAction
 * @memberof gc.gis.module.GCErrorConsole
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 * @param {gc.gis.module.GCErrorConsole} options.instance Modulinstanz
 * @param {gc.gis.log.GCLogLevel} options.level Modulinstanz
 */
gc.gis.module.GCErrorConsole.FilterAction = function( options )
{
    gc.gis.action.GCAbstractAction.call( this, options );

    var self = this;

    this.level  = options.level;
    this.module = options.instance;
    this.active = this.module.isLevelEnabled( this.level );

    this.func = function()
    {
        if( self.active === true )
        {
            self.module.setLevelEnabled( self.level, false );
            self.module.element_panel.element_list.find('.gc-message.gc-'+ self.level ).hide('blind');
        }
        else
        {
            self.module.setLevelEnabled( self.level, true );
            self.module.element_panel.element_list.find('.gc-message.gc-'+ self.level ).show('blind');
        }
        self.active = !self.active;
        self.module._fireEvent( gc.gis.module.GCErrorConsoleEvent.FILTER_TOGGLE, {
            level: self.level
        });
    };
    this.args = [];
};
gc.gis.module.GCErrorConsole.FilterAction.prototype = Object.create( gc.gis.action.GCAbstractAction.prototype );
